module.exports = {
	sub:{
		newipo:'新股添加',
		comname:'公司名稱',
		nature:'上市行業',
		market:'上市板塊',
		status:'上市狀態',
		subdata:'遞表日期',
		profile:'公司業務',
		stockname:'股票名稱',
		stockcode:'股票代碼',
		sponsor:'保薦機構',
		ldata:'上市日期',
		efee:'入場費',
		Board:'每手股數',
		Period:'認購日期',
		grey:'暗盤日期',
		rate:'超額倍數',
		price :'招股價',
		cancel:'取消',
		save:'保存',
		cname:'多個保薦機構請用分號（ ; ）',
		Prospectus:'招股書',
		Editipo:'新股編輯',
		ipomessage:'新股詳情',
		jeb:'金額表',
		dkbl:'貸款比率',
		rs:'日數',
		lx:'息率',
		langan:'請先上傳數據',
		sqsl:'申請數量',
		sqje:'申請金額',
		confirm:'確認',
		pln:'請填寫'
	},
}